import React from 'react'
// eslint-disable-next-line import/no-unresolved
import * as allIcons from '@ant-design/icons/lib/dist'
import { useHistory } from 'react-router-dom';
// import { GlobalOutlined } from '@ant-design/icons'
import useLang from '@/utils/lang'
import styles from './index.module.less'

const Globe = props => {
  const history = useHistory()
  const { style, enScroll = false } = props
  const [lang, changeLang] = useLang()
  const switchLanguage = newLang => {
    if (lang !== newLang) {
      if (newLang === 'en' && history.location.pathname === '/home') {
        if (window.location.host === 'preview.privacy.mi.com') {
          window.location.href = 'http://trust-center-cl45206.staging.ingress.mice.cc.d.xiaomi.net'
        } else if (window.location.host === 'privacy.mi.com') {
          window.location.href = 'https://trust.mi.com'
        }
      } else {
        changeLang(newLang)
      }
    }
  }
  return (
    <div className={styles.container} style={style}>
      <span className={enScroll ? styles.enScrollLanguageName : styles.languageName}>
        <allIcons.GlobalOutlined className={styles.angleDown} />
        <span>{lang === 'zh' ? '简体中文' : 'English'}</span>
      </span>
      <div className={styles.dropdown}>
        <ul>
          <li onClick={() => { switchLanguage('zh') }}>简体中文</li>
          <li onClick={() => { switchLanguage('en') }}>English</li>
        </ul>
      </div>
    </div>
  )
}

export default Globe
